<template>
  <div>
    <div
      v-if="rates"
      class="fixed z-100 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
          >&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          :class="$route.path.includes('_restricted') ? '' : 'rates-container'"
        >
          <div>
            <div @click="closeModal" class="text-4xl cursor-pointer">
              <i class="ni ni-fat-remove viva-green-text"></i>
            </div>
            <div class="bg-card border-card-border relative z-50 flex flex-col flex-col-reverse">
              <div class="flex flex-col items-center justify-center container pb-10 text-center">
                <h1 class="mb-3 md:px-3 text-sm text-center">
                  Your loan application is complete and under review. You will receive an email from
                  VIVA later today sent to {{ $store.getters.personalInformation.email }} regarding
                  the outcome of your application.
                </h1>
                <h2 class="text-center md:px-3 md:text-xl font-semibold mb-3">
                  How was your experience with VIVA Finance?
                </h2>
                <div class="flex items-center justify-center">
                  <button
                    @click="rating = index"
                    aria-label="rate"
                    @mouseleave="hover = 0"
                    @mouseover="hover = index"
                    v-for="index in 5"
                    v-bind:key="index"
                    class="w-full focus:outline-none text-gray-400 flex items-center justify-center py-3"
                    :class="{ 'text-yellow-400': hover >= index || rating >= index }"
                  >
                    <i class="fas fa-star text-4xl md:text-6xl"></i>
                  </button>
                </div>
                <transition name="in--up">
                  <div v-if="rating >= 1" class="w-full md:w-2/3">
                    <Input
                      v-model="comment"
                      type="text"
                      name="Leave a comment (optional)"
                      placeholder="Your Experience..."
                      class="w-full my-4"
                    />
                    <div v-if="error">
                      <p class="text-sm text-red-500 text-center">{{ error }}</p>
                    </div>
                    <div class="w-full flex items-center justify-center">
                      <base-button aria-label="submit" type="primary mt-4" @click="submit">
                        {{ loading ? 'Loading' : 'Submit' }}
                        <i v-if="loading" class="fa fa-spinner fa-spin ml-2"></i>
                      </base-button>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-card bg-white border-card-border md:px-6">
      <div class="w-full pt-3">
        <!-- <div class="container md:px-12 pt-16 pb-6 flex flex-col items-center justify-center"> -->
        <h1 class="text-center text-xl font-semibold text-default pb-4">
          Your Loan Application is Complete and Under Review.
        </h1>
        <h2 class="text-center md:px-20 text-gray-600">
          Please allow an average of 1-2 business days for your application to be processed. You
          will then receive an email from VIVA Finance with the outcome of your application.
        </h2>
        <div class="flex justify-center">
          <img alt="img" :src="require('@/assets/img/sketches/review.svg')" class="md:w-1/3 my-4" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import gql from 'graphql-tag'

export default {
  data: function () {
    return {
      showRatingModal: true,
      error: '',
      comment: '',
      hover: 0,
      loading: true,
      state: '',
      rating: 0,
      rates: false
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      ratingValueGetter: 'ratingValue',
      ratingCommentGetter: 'ratingComment'
    })
  },
  methods: {
    closeModal() {
      this.rates = false
    },
    submit() {
      this.loading = true
      this.$apiClient
        .mutate({
          mutation: gql(`mutation { rates(comment: "${this.comment || 'NONE'}", rating: ${
            this.rating
          }) {
          comment
          rating
        } }`)
        })
        .then(({ data }) => {
          setTimeout(() => {
            this.loading = false
            window.location.replace('/#/loan')
            window.location.reload(true)
          }, 250)
        })
        .catch((e) => {
          console.log(`FE Error in completeUnderReview/submit: ${e}`)
          this.error = e
          this.loading = false
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loading = this.$store.state.signingIn
      this.state = this.$store.getters.loanState
    })
    this.$apiClient.mutate({
      mutation: gql(
        `mutation { creditUnderReviewNextHandler(username: "${this.$store.getters.username}") }`
      )
    })
  },
  watch: {
    loading() {
      this.$nextTick(() => {
        this.state = this.$store.getters.loanState
      })
    },
    state(state) {
      if (state === 'review' && !this.$store.state.rating.rating) {
        setTimeout(() => {
          this.rates = state === 'review' && this.ratingValueGetter === 0
        }, 3000)
      }
    },
    '$store.getters.loanState': function (state) {
      this.state = state
    },
    '$store.state.rating': function (rating) {
      if (rating.rating > 0) {
        this.rates = false
      }
    },
    '$store.state.signingIn': function (signingIn) {
      this.$nextTick(() => {
        this.loading = signingIn
      })
    }
  }
}
</script>

<style>
.rates-container {
  margin-bottom: 300px !important;
  overflow: hidden;
}
</style>
